import { forwardRef, useId } from 'react'
import { Switch as AntSwitch } from 'antd'
import type { SwitchProps as AntSwitchProps } from 'antd'
import './switch.css'

type AntSwitchRef = React.ComponentRef<typeof AntSwitch>

export interface SwitchProps {
  checked?: boolean | null | string
  onChange?: AntSwitchProps['onChange']
  disabled?: boolean
  size?: AntSwitchProps['size']
  label?: string
  loading?: boolean
  value?: boolean
  name?: string
  id?: string
  'aria-label'?: string
  style?: React.CSSProperties
  className?: string
}

export const Switch = forwardRef<AntSwitchRef, SwitchProps>(function Switch(
  {
    checked,
    onChange,
    disabled,
    size,
    label,
    loading,
    id: idProp,
    name,
    'aria-label': ariaLabel,
    ...rest
  },
  ref,
) {
  const fallbackId = useId()
  const id = idProp ?? fallbackId
  const accessibleName = ariaLabel ?? label
  return (
    <div className='flex items-center gap-2'>
      <AntSwitch
        ref={ref}
        id={id}
        {...({ name: name ?? id } as { name?: string })}
        aria-label={accessibleName}
        className='glasspro-switch'
        checked={!!checked}
        onChange={onChange}
        disabled={disabled}
        size={size}
        loading={loading}
        {...rest}
      />
      {label && (
        <label htmlFor={id} className='text-sm text-(--form-header-title)'>
          {label}
        </label>
      )}
    </div>
  )
})
